{
	"AF": "Afganist\u00e1n",
	"AL": "Albania",
	"AQ": "Antartida",
	"DZ": "Argelia",
	"AS": "Samoa Americana",
	"AD": "Andorra",
	"AO": "Angola",
	"AG": "Antigua y Barbuda",
	"AZ": "Azerbaiy\u00e1n",
	"AR": "Argentina",
	"AU": "Australia",
	"AT": "Austria",
	"BS": "Bahamas",
	"BH": "Bahrein",
	"BD": "Bangladesh",
	"AM": "Armenia",
	"BB": "Barbados",
	"BE": "B\u00e9lgica",
	"BM": "Bermudas",
	"BT": "Bhut\u00e1n",
	"BO": "Bolivia",
	"BA": "Bosnia y Herzegovina",
	"BW": "Botsuana",
	"BV": "Isla Bouvet",
	"BR": "Brasil",
	"BZ": "Belice",
	"IO": "Territorio Brit\u00e1nico del Oc\u00e9ano \u00cdndico",
	"SB": "Islas Salom\u00f3n",
	"VG": "Islas V\u00edrgenes Brit\u00e1nicas",
	"BN": "Brun\u00e9i Darussalam",
	"BG": "Bulgaria",
	"MM": "Birmania",
	"BI": "Burundi",
	"BY": "Bielorrusia",
	"KH": "Camboya",
	"CM": "Camer\u00fan",
	"CA": "Canad\u00e1",
	"CV": "Cabo Verde",
	"KY": "Islas Caim\u00e1n",
	"CF": "Rep\u00fablica Centroafricana",
	"LK": "Sri lanka",
	"TD": "Chad",
	"CL": "Chile",
	"CN": "China",
	"TW": "Taiw\u00e1n",
	"CX": "Isla de Navidad",
	"CC": "Islas Cocos (Keeling)",
	"CO": "Colombia",
	"KM": "Comoras",
	"YT": "Mayotte",
	"CG": "Rep\u00fablica del Congo",
	"CD": "Rep\u00fablica Democr\u00e1tica del Congo",
	"CK": "Islas Cook",
	"CR": "Costa Rica",
	"HR": "Croacia",
	"CU": "Cuba",
	"CY": "Chipre",
	"CZ": "Rep\u00fablica Checa",
	"BJ": "Ben\u00edn",
	"DK": "Dinamarca",
	"DM": "Dominica",
	"DO": "Rep\u00fablica Dominicana",
	"EC": "Ecuador",
	"SV": "El Salvador",
	"GQ": "Guinea Ecuatorial",
	"ET": "Etiop\u00eda",
	"ER": "Eritrea",
	"EE": "Estonia",
	"FO": "Islas Feroe",
	"FK": "Islas Malvinas",
	"GS": "Islas Georgias del Sur y Sandwich del Sur",
	"FJ": "Fiyi",
	"FI": "Finlandia",
	"AX": "Islas de \u00c5land",
	"FR": "Francia",
	"GF": "Guayana Francesa",
	"PF": "Polinesia Francesa",
	"DJ": "Yibuti",
	"GA": "Gab\u00f3n",
	"GE": "Georgia",
	"GM": "Gambia",
	"PS": "Palestina",
	"DE": "Alemania",
	"GH": "Ghana",
	"GI": "Gibraltar",
	"KI": "Kiribati",
	"GR": "Grecia",
	"GL": "Groenlandia",
	"GD": "Granada",
	"GP": "Guadeloupe",
	"GU": "Guam",
	"GT": "Guatemala",
	"GN": "Guinea",
	"GY": "Guyana",
	"HT": "Hait\u00ed",
	"VA": "Ciudad del Vaticano",
	"HN": "Honduras",
	"HK": "Hong Kong",
	"HU": "Hungr\u00eda",
	"IS": "Islandia",
	"IN": "India",
	"ID": "Indonesia",
	"IR": "Ir\u00e1n",
	"IQ": "Irak",
	"IE": "Irlanda",
	"IL": "Israel",
	"IT": "Italia",
	"CI": "Costa de Marfil",
	"JM": "Jamaica",
	"JP": "Jap\u00f3n",
	"KZ": "Kazajist\u00e1n",
	"JO": "Jordania",
	"KE": "Kenia",
	"KP": "Corea del Norte",
	"KR": "Corea del Sur",
	"KW": "Kuwait",
	"KG": "Kirguist\u00e1n",
	"LA": "Laos",
	"LB": "L\u00edbano",
	"LS": "Lesoto",
	"LV": "Letonia",
	"LR": "Liberia",
	"LY": "Libia",
	"LI": "Liechtenstein",
	"LT": "Lituania",
	"LU": "Luxemburgo",
	"MO": "Macao",
	"MG": "Madagascar",
	"MW": "Malawi",
	"MY": "Malasia",
	"MV": "Islas Maldivas",
	"ML": "Mali",
	"MT": "Malta",
	"MQ": "Martinique",
	"MR": "Mauritania",
	"MU": "Mauricio",
	"MX": "M\u00e9xico",
	"MC": "M\u00f3naco",
	"MN": "Mongolia",
	"MD": "Moldavia",
	"ME": "Montenegro",
	"MS": "Montserrat",
	"MA": "Marruecos",
	"MZ": "Mozambique",
	"OM": "Om\u00e1n",
	"NA": "Namibia",
	"NR": "Nauru",
	"NP": "Nepal",
	"NL": "Pa\u00edses Bajos",
	"CW": "Curacao",
	"AW": "Aruba",
	"SX": "Sint Maarten",
	"NC": "Nueva Caledonia",
	"VU": "Vanuatu",
	"NZ": "Nueva Zelanda",
	"NI": "Nicaragua",
	"NE": "Niger",
	"NG": "Nigeria",
	"NU": "Niue",
	"NF": "Isla Norfolk",
	"NO": "Noruega",
	"MP": "Islas Marianas del Norte",
	"UM": "Islas Ultramarinas Menores de Estados Unidos",
	"FM": "Micronesia",
	"MH": "Islas Marshall",
	"PW": "Palau",
	"PK": "Pakist\u00e1n",
	"PA": "Panam\u00e1",
	"PG": "Pap\u00faa Nueva Guinea",
	"PY": "Paraguay",
	"PE": "Per\u00fa",
	"PH": "Filipinas",
	"PN": "Islas Pitcairn",
	"PL": "Polonia",
	"PT": "Portugal",
	"GW": "Guinea-Bissau",
	"TL": "Timor Oriental",
	"PR": "Puerto Rico",
	"QA": "Qatar",
	"RE": "Reuni\u00f3n",
	"RO": "Ruman\u00eda",
	"RU": "Rusia",
	"RW": "Ruanda",
	"BL": "San Bartolom\u00e9",
	"SH": "Santa Elena",
	"KN": "San Crist\u00f3bal y Nieves",
	"AI": "Anguila",
	"LC": "Santa Luc\u00eda",
	"PM": "San Pedro y Miquel\u00f3n",
	"VC": "San Vicente y las Granadinas",
	"SM": "San Marino",
	"ST": "Santo Tom\u00e9 y Pr\u00edncipe",
	"SA": "Arabia Saudita",
	"SN": "Senegal",
	"RS": "Serbia",
	"SC": "Seychelles",
	"SL": "Sierra Leona",
	"SG": "Singapur",
	"SK": "Eslovaquia",
	"VN": "Vietnam",
	"SI": "Eslovenia",
	"SO": "Somalia",
	"ZA": "Sud\u00e1frica",
	"ZW": "Zimbabue",
	"ES": "Espa\u00f1a",
	"SS": "Sud\u00e1n del Sur",
	"EH": "Sahara Occidental",
	"SD": "Sud\u00e1n",
	"SR": "Surin\u00e1m",
	"SJ": "Svalbard y Jan Mayen",
	"SZ": "Swazilandia",
	"SE": "Suecia",
	"CH": "Suiza",
	"SY": "Siria",
	"TJ": "Tayikist\u00e1n",
	"TH": "Tailandia",
	"TG": "Togo",
	"TK": "Tokelau",
	"TO": "Tonga",
	"TT": "Trinidad y Tobago",
	"AE": "Emiratos \u00c1rabes Unidos",
	"TN": "Tunez",
	"TR": "Turqu\u00eda",
	"TM": "Turkmenist\u00e1n",
	"TC": "Islas Turcas y Caicos",
	"TV": "Tuvalu",
	"UG": "Uganda",
	"UA": "Ucrania",
	"MK": "Maced\u00f4nia del Norte",
	"EG": "Egipto",
	"GB": "Reino Unido",
	"GG": "Guernsey",
	"JE": "Jersey",
	"IM": "Isla de Man",
	"TZ": "Tanzania",
	"US": "Estados Unidos de Am\u00e9rica",
	"VI": "Islas V\u00edrgenes de los Estados Unidos",
	"BF": "Burkina Faso",
	"UY": "Uruguay",
	"UZ": "Uzbekist\u00e1n",
	"VE": "Venezuela",
	"WF": "Wallis y Futuna",
	"WS": "Samoa",
	"YE": "Yemen",
	"ZM": "Zambia"
}